import { render, staticRenderFns } from "./AdminCities.vue?vue&type=template&id=084beb8d"
import script from "./AdminCities.vue?vue&type=script&lang=js"
export * from "./AdminCities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports